import _ from 'lodash'
import ClientAuth from 'alto-react-client-auth/lib/client'
import Terminal from './models/terminal'

class CanteenAuthStorage extends ClientAuth.Storage
  @fields: ClientAuth.Storage.fields.concat([
    { name: 'isTerminal' }
    { name: 'terminal', \
      serializer:   Terminal.serialize.bind(Terminal), \
      deserializer: Terminal.deserialize.bind(Terminal) }
  ])

class CanteenAuthBackend extends ClientAuth.Backend
  getTerminalToken: (cardNumber) ->
    @backend.request('POST', '/canteen/get_terminal_token',
                     body: { card_number: cardNumber, secret: @_getTerminalSecret() })
      .then(@getTokenHandler)

  getTokenHandler: (response) ->
    _.assign({ terminal: response.terminal and Terminal.deserialize(response.terminal) },
             super(response))

  isRegisteredTerminal: ->
    @backend.request('GET', '/canteen/is_registered_terminal',
                     qs: { secret: @_getTerminalSecret() })
      .then ({ terminal, is_registered }) ->
        { terminal: terminal and Terminal.deserialize(terminal), isRegistered: is_registered }

  _getTerminalSecret: ->
    window.localStorage.getItem('terminal-secret') ? ''

export default class CanteenAuth extends ClientAuth
  @storageClass: CanteenAuthStorage
  @backendClass: CanteenAuthBackend

  terminalLogin: (cardNumber) ->
    @backend.getTerminalToken(cardNumber).then (result) =>
      @storage.save(_.assign(result, isTerminal: true))

  Object.defineProperty(@::, 'isTerminal',
                        get: -> @authInfo?.isTerminal,
                        set: (isTerminal) -> @storage.update({ isTerminal }))

  isRegisteredTerminal: (args...) -> @backend.isRegisteredTerminal(args...)

CanteenAuth.Storage = CanteenAuthStorage
CanteenAuth.Backend = CanteenAuthBackend
